import _ from 'lodash';
import { useContext } from 'react';
import ApplicationContext from '../ApplicationContext';
import { useAppDispatch } from '../app/hooks';
import { DataFetchResult } from '../components/common/AbstractListView';
import { getJobFromName, listViewPagePerBatch, listViewPageSize } from '../components/common/JobListView';
import fastStorage from '../fastStorage';
import { setInStorage } from '../features/storageSlice';

import { FilterStorageVersion, getInitialSearch } from '../filtering';

import { JobNames } from '../framework.core/JobNames';
import JobListViewContext from '../components/common/JobListViewContext';

interface IndexByAny {
  [x: string]: any
};

// export enum CustomEditId {
//   OiQuotation = 'oiQuotation',
//   OeQuotation = 'oeQuotation',
//   AiQuotation = 'aiQuotation',
//   AeQuotation = 'aeQuotation',
// }


export const storageKeyMap = new Map<string, string>
  ([
    [JobNames.OIMbl, "/common/joblistview/mbl/oceanImport"],
    [JobNames.OIHbl, "/common/joblistview/hbl/oceanImport"],
    [JobNames.OILoad, "/common/joblistview/OILD/oceanImport"],
    [JobNames.OIVessel, "/common/joblistview/OIVS/oceanImport"],
    [JobNames.OEMbl, "/common/joblistview/oeMbl/oceanExport"],
    [JobNames.OEHbl, "/common/joblistview/oeHbl/oceanExport"],
    [JobNames.OIContainer, "/common/joblistview/OICN/oceanImport"],
    // [CustomEditId.OiQuotation, "/common/joblistview/oiQuotation/oceanImport?parentOp=oceanImport"],
    // [CustomEditId.OeQuotation, "/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport"],
    // [CustomEditId.AiQuotation, "/common/joblistview/aiQuotation/airImport?parentOp=airImport"],
    // [CustomEditId.AeQuotation, "/common/joblistview/aeQuotation/airExport?parentOp=airExport"],
    [JobNames.OIQuotation, "/common/joblistview/oiQuotation/oceanImport?parentOp=oceanImport"],
    [JobNames.OEQuotation, "/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport"],
    [JobNames.AIQuotation, "/common/joblistview/aiQuotation/airImport?parentOp=airImport"],
    [JobNames.AEQuotation, "/common/joblistview/aeQuotation/airExport?parentOp=airExport"],

    [JobNames.OELoad, "/common/joblistview/oeLoadPlan/oceanExport"],
    [JobNames.OEBook, "/common/joblistview/oeBooking/oceanExport"],
    [JobNames.OEContainer, "/common/joblistview/OECN/oceanExport"],
    // [JobNames.Invoice, "/common/joblistview/invoice/accounting"],
    [JobNames.Invoice, "/common/joblistview/invoice/accounting?parentOp=billings"],
    [JobNames.OpInvoice, "/common/joblistview/invoice/accounting?parentOp=billings"],
    // [JobNames.OpRptInvoice, "/common/joblistview/invoice/accounting?parentOp=opReport"],
    // [JobNames.Bill, "/common/joblistview/bill/accounting"],
    [JobNames.Bill, "/common/joblistview/bill/accounting?parentOp=billings"],
    [JobNames.OpBill, "/common/joblistview/bill/accounting?parentOp=billings"],
    // [JobNames.OpRptBill, "/common/joblistview/bill/accounting?parentOp=opReport"],
    // [JobNames.CrDb, "/common/joblistview/crdb/accounting"],
    [JobNames.CrDb, "/common/joblistview/crdb/accounting?parentOp=billings"],
    [JobNames.OpCrDb, "/common/joblistview/crdb/accounting?parentOp=billings"],
    // [JobNames.OpRptCrDb, "/common/joblistview/crdb/accounting?parentOp=opReport"],
    //<pt220128: why???>
    // [JobNames.InvoiceOi, "/common/joblistview/invoice/oceanImport"],
    // [JobNames.InvoiceOe, "/common/joblistview/invoice/oceanExport"],
    // [JobNames.BillOi, "/common/joblistview/bill/oceanImport"],
    // [JobNames.CrDbOi, "/common/joblistview/crdb/oceanImport"],
    [JobNames.Company, "/common/joblistview/company/customer"],
    [JobNames.AIMbl, "/common/joblistview/aiMawb/airImport"],
    [JobNames.AIHbl, "/common/joblistview/aiHawb/airImport"],
    [JobNames.AirQuotation, "/common/joblistview/aiQuotation/airImport"],
    [JobNames.AEMbl, "/common/joblistview/aeMawb/airExport"],
    [JobNames.AEHbl, "/common/joblistview/aeHawb/airExport"],

    [JobNames.OtherOP, "/common/joblistview/otherShipment/otherShipment"],
    [JobNames.OtQuotation, "/common/joblistview/otQuotation/otherShipment?parentOp=otherShipment"],
    [JobNames.WHRcpt, "/common/joblistview/whReceipt/whReceipt"],
    [JobNames.WHRcv, "/common/joblistview/whReceiving/warehousing"],
    [JobNames.WHShip, "/common/joblistview/whShipping/warehousing"],
    [JobNames.WHCustomer, "/common/joblistview/whCompany/warehousing"],
    [JobNames.WHItem, "/common/joblistview/whItem/warehousing"],
    [JobNames.WHLoc, "/common/joblistview/whLocation/warehousing"],
    [JobNames.WHStorageInv, "/common/joblistview/whStorageInvoice/warehousing"],
    [JobNames.WHInvenSummary, "/common/joblistview/whInventory/warehousing"],
    [JobNames.WHInvenDetail, "/common/joblistview/whInOut/warehousing"],
    [JobNames.WHInvoice, "/common/joblistview/invoice/warehousing"],
    [JobNames.WHBill, "/common/joblistview/bill/warehousing"],
    [JobNames.WHCrDb, "/common/joblistview/crdb/warehousing"],

    [JobNames.MemoList, "/common/joblistview/utMemotask/utility"],
    [JobNames.FileAttach, "/common/joblistview/utAttachedfile/utility"],
    [JobNames.LogMail, "/common/joblistview/utEmail/utility"],
    [JobNames.LogPrint, "/common/joblistview/utPrint/utility"],
    [JobNames.LogFax, "/common/joblistview/utFax/utility"],
    [JobNames.LogCommunication, "/common/joblistview/utCommunication/utility"],
    [JobNames.LogAmsIsf, "/common/joblistview/utAmsIsf/utility"],

    [JobNames.AllPayment, "/common/joblistview/acAllPayment/accounting"],
    [JobNames.CustPayment, "/common/joblistview/acCustomerPayment/accounting"],
    [JobNames.AgntPayment, "/common/joblistview/acAgentPayment/accounting"],
    [JobNames.BillPayment, "/common/joblistview/acBillPayment/accounting"],
    [JobNames.CCPayment, "/common/joblistview/acCCPayment/accounting"],
    //[JobNames.GInvo, "/common/joblistview/acGeneralInvoice/accounting"],
    [JobNames.GInvo, "/common/joblistview/acGeneralInvoice/accounting?parentOp=billings"],
    //[JobNames.GBill, "/common/joblistview/acGeneralBill/accounting"],
    [JobNames.GBill, "/common/joblistview/acGeneralBill/accounting?parentOp=billings"],
    [JobNames.CheckDeposit, "/common/joblistview/acDepositCheckClear/accounting"],
    [JobNames.CCClear, "/common/joblistview/acCreditCardClear/accounting"],
    [JobNames.CustPaymentMemo, "/common/joblistview/acCustomerPaymentMemo/accounting"],

    [JobNames.PayrollSummary, "/common/joblistview/acPayrollSummary/accounting"],
    [JobNames.Payroll2, "/common/joblistview/acPayroll2/accounting"],
    [JobNames.PrepaidExpenseAdjustment, "/common/joblistview/acPrepaidExpenseAdjustment/accounting"],
    [JobNames.DepreciationAdjustment, "/common/joblistview/acDepreciationAdjustment/accounting"],
    [JobNames.AmortizationAdjustment, "/common/joblistview/acAmortizationAdjustment/accounting"],
    [JobNames.BadDebtExpense, "/common/joblistview/acBadDebtProcessing/accounting"],
    [JobNames.SalesTaxReturn, "/common/joblistview/acSalesTaxReturn/accounting"],
    [JobNames.Distribution, "/common/joblistview/acDistribution/accounting"],
    [JobNames.PaymentPrep, "/common/joblistview/acPaymentPrep/accounting"],
    [JobNames.AdvanceSales, "/common/joblistview/acAdvanceSales/accounting"],

    [JobNames.BankRecon, "/common/joblistview/acBankRecon/accounting"],
    [JobNames.BankTransfer, "/common/joblistview/acBankTransfer/accounting"],

    [JobNames.SlipJournal, "/common/joblistview/acJournal/accounting"],
    [JobNames.BatchRecog, "/common/joblistview/acBatchRecogHistory/accounting"],
    [JobNames.BatchPrintHistory, "/common/joblistview/acBatchPrintHistory/accounting?parentOp=billings"],

    [JobNames.OIMPims, "/common/joblistview/OIMP/oceanImport"],
    [JobNames.OIHPims, "/common/joblistview/OIHP/oceanImport"],
    [JobNames.OEMPims, "/common/joblistview/OEMP/oceanExport"],
    [JobNames.OEHPims, "/common/joblistview/OEHP/oceanExport"],
    [JobNames.AIMPims, "/common/joblistview/AIMP/airImport"],
    [JobNames.AIHPims, "/common/joblistview/AIHP/airImport"],
    [JobNames.AEMPims, "/common/joblistview/AEMP/airExport"],
    [JobNames.AEHPims, "/common/joblistview/AEHP/airExport"],
    [JobNames.MyEvent, "/common/joblistview/MYEVT/myEvent"],

    [JobNames.ISF, "/common/joblistview/ISFL/isf"],

    [JobNames.AMSMaster, "/common/joblistview/AMSM/ams"],
    [JobNames.AMSVoyage, "/common/joblistview/AMSV/ams"],
    [JobNames.AMSHouse, "/common/joblistview/AMSH/ams"],
    [JobNames.AMSUser, "/common/joblistview/AMSU/ams"],
    [JobNames.AMSBranch, "/common/joblistview/AMBR/ams"],
    [JobNames.AMSHistory, "/common/joblistview/AMHI/ams"],
    [JobNames.AMSBilling, "/common/joblistview/AMBI/ams"],
    [JobNames.AMSC1History, "/common/joblistview/AMC1/ams"],

    [JobNames.ACIManifest, "/common/joblistview/ACIEM/oceanImport"],
    [JobNames.RptCustomerShipment, "/common/joblistview/RPCSP/shipmentStatus"],
    [JobNames.AllContainer, "/common/joblistview/allContainer/cntr"],
    [JobNames.OtherContainer, "/common/joblistview/OTOPC/otherShipment"],
    [JobNames.TaskList, "/common/joblistview/TASKL/myTask"],
    [JobNames.Query, "/common/joblistview/QURY/opReport"],
    [JobNames.CustomizedList, "/common/joblistview/CTLST/opReport"],
    [JobNames.AICenter, "/common/joblistview/AICTR/aiCenter"],
    [JobNames.EmailTemplate, "/common/joblistview/utEmailTemplate/utility"],
    [JobNames.ReportScheduling, "/common/joblistview/RPTSD/shipmentStatus"],
    [JobNames.ReportHistory, "/common/joblistview/RPHIS/shipmentStatus"],
  ]);


/**
 * Set edited id to make sure given row is being refreshed when list is shown
 *
 * @export
 * @param {string} jobNames - jobNames from framework.core.JobNames.ts
 */
export default function useSetEditedId(jobNames: Array<string>) {
  jobNames.forEach(jobName => {
    // ListView에서 사용할 때 None으로 올 경우가 있음
    if(jobName === JobNames.None){
      return;
    }
    else if (!storageKeyMap.has(jobName)) {
      throw new Error(`Job name '${jobName}' is not supported'`);
    }
  })

  const dispatch = useAppDispatch();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);

  async function setSavedEntityForUrl(id: string, url: string, isNew: boolean, jobName: string, isDelete: boolean = false, refreshAll = false, queryOpType: string = '') {
    let tempListData: DataFetchResult;
    const job = getJobFromName(jobName);
    const listView = job.generateListView();
    const listDataStorageKey = `ifms-list-data-${storageKeyMap.get(jobName)}`;
    const oriListData: Array<any> = fastStorage[listDataStorageKey];

    if (!oriListData) return;

    const tempOriData = (oriListData);

    const updateStorageAndDispatch = () => {
      const obj: IndexByAny = {};
      const otherStorageKey = `editedId-${FilterStorageVersion}-${url}`;
      const filterObj = {
        editedId: id,
        isNew,
        isDelete,
        refreshAll,
        queryOpType,
      };

      if (obj[otherStorageKey]?.isNew)
        filterObj.isNew = true;
      else
        obj[otherStorageKey] = filterObj;
      
      dispatch(setInStorage(obj));
    };
    if (isDelete) {
      //const oriDataIndex = oriListData.findIndex(x => x.id === Number(id));
      //tempOriData.splice(oriDataIndex, 1);
      updateStorageAndDispatch();
    }
    else {
      if (!isNew) {
        tempListData = await listView.fetchAndFormatData(appContext.api, { ...getInitialSearch(), ...{ general1: 'id', generalText1: id ?? '', pageSize: listViewPageSize, pagePerBatch: listViewPagePerBatch } }, 1, listViewPageSize * listViewPagePerBatch, _.isEmpty(queryOpType) ? undefined : queryOpType, appContext.user, jobListContext, false);

      if (!tempListData || !tempListData.data || tempListData.data.length <= 0) {
        if (refreshAll) {
          updateStorageAndDispatch();
        }
        return;
      }

      const oriDataIndex = oriListData.findIndex(x => x.id === tempListData.data[0].id);

      if (oriDataIndex === -1)
        tempOriData.unshift(tempListData.data[0]);
      else
        tempOriData[oriDataIndex] = tempListData.data[0];

      updateStorageAndDispatch();
      }
      else {
        //Payment에서 order가 postDate로 되어 문제가 발생했음, 이쪽을 타는 모든 ListItem에 Id 가 존재함
        //261028: JournalLedgerListItem은 Id가 없어(id = 행 번호) 'id' 검색 시 오류 발생.
        //useSetEditedId를 쓰는 ListItem 중 Id가 없는 것은 JournalLedgerListItem 하나이며, 저장 시 이 함수를 쓰지 않고 JournalView.refreshJournalList()에서 직접 List에 반영함 (New: 맨 위에 추가, Edit: 기존 위치에서 교체).
        tempListData = await listView.fetchAndFormatData(appContext.api, { ...getInitialSearch(), ...{ general1: 'id', generalText1: id ?? '', pageSize: listViewPageSize, pagePerBatch: listViewPagePerBatch } }, 1, listViewPageSize * listViewPagePerBatch, _.isEmpty(queryOpType) ? undefined : queryOpType, appContext.user, jobListContext, false);

        //if (tempData.length === appContext.defaultPageSize) tempData.splice(tempData.length - 1); //delete last data
        if (!tempListData || !tempListData.data || tempListData.data.length <= 0) {
          return;
        }

        const insertItem = tempListData.data.filter(cur => !tempOriData.some(x => x.id === cur.id));

        if (insertItem.length === 0)
          tempOriData.unshift(tempListData.data[0]); //add data at first index
        else
          tempOriData.unshift(insertItem[0]);

        updateStorageAndDispatch();
      }
    }
  }

  /**
   * Set saved entity id
   *
   * @param {string} id
   */
  function setSavedEntity(id: string, isNew: boolean, isDelete: boolean = false, refreshAll = false, queryOpType: string = '') {
    jobNames.forEach(jobName => setSavedEntityForUrl(id, storageKeyMap.get(jobName)!, isNew, jobName, isDelete, refreshAll, queryOpType));
  }

  return setSavedEntity;
}
